<script lang="ts">
  import {LotType} from '../types/enums'
  import {t} from '../../i18n/i18n'
  import type {Writable} from 'svelte/store'
  import type {Lot} from '../optimizer/lot'
  import {getContext} from 'svelte'

  const lot: Writable<Lot> = getContext('lot')
	const maleLotTypes = [LotType.MATERIAL_SALE, LotType.MATERIAL_NEED]

	export let name = ''
	export let showSaasData: boolean = false
	export let saasOwnerName = ''
	export let tenantName = ''
	export let lotType: LotType | undefined = $lot?.type

	let lotTypeText: string
	let addressTextPrefix: string
	let addressTextSuffix: string
  // this distinction is just to differentiate between 'Dein' and 'Deine'
	let address = `${$lot?.address.zip} ${$lot?.address.city}`
	let offerSiteLocation = `${$lot?.offerSiteLocation?.zip} ${$lot?.offerSiteLocation?.city}`
	let saasSalutationData: string = $t('UI.pubPage.salutation.saasData', {
		saasOwnerName: saasOwnerName,
		tenantName: tenantName,
		address: address
	})

	$: lotType = $lot?.type
	$: (lotType,
		(addressTextPrefix = lotType === LotType.TRANSPORT && offerSiteLocation ? ' von ' : ' in '))
	$: (lotType,
		(addressTextSuffix = lotType === LotType.TRANSPORT && offerSiteLocation ? ' nach ' : ''))
	$: (lotType,
		(lotTypeText = lotType
      ? (maleLotTypes.includes(lotType) ? 'Dein ' : 'Deine ') + `<b>${$t('LotType.' + lotType)}</b>`
      : 'Dein Projekt'))
</script>

<div class="salutation">
	{#if name !== ''}
		<h1>Hallo {name},</h1>
	{:else}
		<h1 class="salutation-large">Hallo,</h1>
	{/if}
	{#if showSaasData}
		<span class="salutation-small">{@html saasSalutationData}</span>
	{:else}
		<div class="salutation-text">
			<span class="salutation-small">hier {@html lotTypeText}{addressTextPrefix}</span>&nbsp;
			<span class="green salutation-small">{address}</span>
			{#if lotType === LotType.TRANSPORT && offerSiteLocation}
				&nbsp;<span class="salutation-small">{addressTextSuffix}</span>&nbsp;
				<span class="green salutation-small">{offerSiteLocation}</span>
			{/if}
			<span class="salutation-small">:</span>
		</div>
	{/if}
</div>

<style lang="scss">
	@import '$styles/global';

	.salutation {
		@include flex-col($alignment: flex-start);

		padding-bottom: 1rem;
	}

	.salutation-text {
		@include flex-row($alignment: flex-start);

		flex-wrap: wrap;
	}

	.salutation-small {
		@include roboto-font(1.875rem, 400, 1rem, black);
	}

	.green {
		@include roboto-font(1.875rem, 400, 1rem, $primaryColor);
	}
</style>
